exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/resolve-url-loader!./~/sass-loader?sourceMap!./src/assets/skins/simia.scss
// module id = 67
// module chunks = 0